import { CheckCircle2, Loader2 } from "lucide-react";
import { useShell } from "@/components/Shell";
import { relative, absolute } from "@/lib/format";

/**
 * Page header for Home: campground name + a passive sync status.
 *
 * There's no manual sync button here — the first sync runs automatically
 * (see Shell), and re-syncing after Roverpass edits lives in Knowledge →
 * "Sync from Roverpass".
 */
export function HeaderStrip() {
  const { home, autoSyncing } = useShell();
  if (!home) return null;

  const last = home.last_sync;
  const hasSynced = !!last?.completed_at;

  return (
    <div className="min-w-0">
      <h1 className="text-2xl font-medium text-text-strong">{home.campground.name}</h1>
      <div className="mt-1 flex items-center gap-1.5 text-sm text-text-soft">
        {autoSyncing ? (
          <>
            <Loader2 size={14} className="animate-spin text-coral" />
            <span>Setting up your bot…</span>
          </>
        ) : hasSynced ? (
          <>
            <CheckCircle2 size={14} className="text-success" />
            <span title={absolute(last?.completed_at)} className="cursor-default">
              Synced {relative(last?.completed_at)}
            </span>
          </>
        ) : (
          <span className="text-text-faint">Your campground assistant</span>
        )}
      </div>
    </div>
  );
}
